//Requires configuration options
//HTMLHelpers - UseStaticDepartureDropdown : true
//WebConfig   - EnableStaticDepartureDropdown: true
//WebConfig   - FixedDepartureAirportOptions : (string value )

namespace SearchUnit {

    interface IAirport {
        Title: string;
        Code: string;
        titleCode: string;
    }

    interface ISearchUnitService {
        getAirport(code:string) : ng.IPromise<IAirport>;
        setDepartureAirports(airport: IAirport | null);
        getSelectedDepartureAirport();
    }

    interface IAirportOptions {
        options: IAirport[];
        selected: IAirport | null;
    }

    class FixedDepartureDropdown {

        options : string[];
        selected : IAirport[];
        data : string;
        airports: IAirportOptions = {
             options: [],
             selected: null
        };

        constructor( private searchUnitService: ISearchUnitService,
                    private $q: ng.IQService)
        {
            $q.all(this.data.split(',').map(searchUnitService.getAirport)).then(results => {
                this.airports.options = results.map(r => <IAirport>_.assign(r, {titleCode:`${r.Title}, ${r.Code}`}));

                if(this.selected && this.selected.length > 0){
                    _.each(this.airports.options, (airport) => {
                        if(this.selected[0].Code === airport.Code){
                            this.airports.selected = airport;
                        }
                    });
                }

                //ensure search criteria is persisted
                const preSelectedAirport = searchUnitService.getSelectedDepartureAirport();
                if ( preSelectedAirport ) {
                    const preSelectedIndex = this.airports.options.filter(airport => {
                      return airport.Code === preSelectedAirport.Code;
                    });
                    if ( preSelectedIndex.length ) {
                        this.airports.selected = preSelectedIndex[0];
                    }
                }
            });
        }

        onDepartureAirportChange():void {
            this.searchUnitService.setDepartureAirports(this.airports.selected);
        };
    }

    angular
    .module('searchUnit')
    .directive('fixedDepartureDropdown', fixedDepartureDropdown);

    function fixedDepartureDropdown(searchUnitService) {
        return {
            restrict: 'E',
            replace: true,
            scope: {},
            controllerAs: 'dd',
            bindToController: {
                data: '=',
                selected: '='
            },
            templateUrl: 'partials/home/directivetemplate?type=FixedDepartureDropdown',
            controller : FixedDepartureDropdown
        };
    }
}
